import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './api';
import { ThemeProvider } from './ThemeContext';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import ClientDetail from './pages/ClientDetail';
import PublicClientView from './pages/PublicClientView';
import ClientPortal from './pages/ClientPortal';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-main)' }}>
        <div className="text-center">
          <div className="spinner mx-auto mb-4" />
          <p style={{ color: 'var(--text-muted)' }}>Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return children;
};

// Main App Content
const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const [selectedClient, setSelectedClient] = useState(null);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-main)' }}>
        <div className="text-center">
          <div className="spinner mx-auto mb-4" />
          <p style={{ color: 'var(--text-muted)' }}>Cargando Antropia...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Client Portal */}
      <Route path="/portal/:accessToken" element={<ClientPortal />} />
      <Route path="/portal/:accessToken/login" element={<ClientPortal />} />
      
      {/* Public Client View (legacy) */}
      <Route path="/client/:accessToken" element={<PublicClientView />} />
      
      {/* Auth Page */}
      <Route 
        path="/auth" 
        element={
          isAuthenticated ? <Navigate to="/" replace /> : <AuthPage />
        } 
      />
      
      {/* Protected Dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {selectedClient ? (
              <ClientDetail 
                client={selectedClient} 
                onBack={() => setSelectedClient(null)} 
              />
            ) : (
              <Dashboard onSelectClient={setSelectedClient} />
            )}
          </ProtectedRoute>
        }
      />
      
      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
